import saveFile from "@cirrus/legacy/app-common/utils/saveFile.es6"

import { httpRequest, endpoint } from "@cirrus/core/http"

export const perfomanceRootGET = async (params) =>
  await httpRequest.get(endpoint.withRoot(`/api/v1/author/reports/assessment-performance`), {
    params,
  })

export const perfomanceExportPOST = async (params) =>
  await httpRequest.post(
    endpoint.withRoot(`/api/v1/author/reports/assessment-performance/export`),
    params,
  )

export const perfomanceDownloadGET = async ({ url, date }) =>
  await httpRequest
    .get(
      endpoint.withRoot(`/api/v1/author/reports/assessment-performance/export/download?url=${url}`),
      {
        responseType: "arraybuffer",
      },
    )
    .then((response) => {
      if (response.status === 204) {
        return
      }

      saveFile(response.data, {
        fileName: `Assessment Performance Statistics (${date.split("T")[0]}).xlsx`,
      })

      return { fileName }
    })

export const overviewGET = async (examResultId) => {
  return await httpRequest.get(endpoint.withRoot(`/api/reports/${examResultId}/results/overview`))
}

export const rootGET = async (params) => {
  return await httpRequest.get(endpoint.withRoot(`/api/v1/author/reports/results`), params)
}

export const itemGET = async ({ params, parentId }) => {
  if (!parentId) {
    return await httpRequest.post(
      endpoint.withRoot("/api/v1/author/reports/results/by-candidate"),
      params,
    )
  }

  return await httpRequest.get(endpoint.withRoot(`/api/v1/author/reports/results/${parentId}`), {
    params,
  })
}

export const getCandidatesCount = async (params) =>
  await httpRequest.post(
    endpoint.withRoot(
      `/api/v1/author/reports/results/${
        params.filter.parentId ? params.filter.parentId + "/" : ""
      }export/count`,
    ),
    params,
  )

export const startExportFile = async (params) =>
  await httpRequest.post(
    endpoint.withRoot(
      `/api/v1/author/reports/results/${
        (params.filter || {}).parentId
          ? `${params.filter.parentId}/`
          : params.filter.viewBy === 3
          ? "by-candidate/"
          : ""
      }export`,
    ),
    params,
  )

export const getProctorioLink = async (scheduleId) =>
  await httpRequest.get(
    endpoint.withRoot(`/api/v1/author/reports/results/${scheduleId}/proctor-link`),
  )

export const resultsAvailableGroupsGET = async ({ params }) => {
  return await httpRequest.get(
    endpoint.withRoot(
      `/api/v1/author/data-list/available-groups?search=${params.search}&limit=${params.limit}`,
    ),
  )
}

export const topicsGET = async (params) => {
  return await httpRequest.get(
    endpoint.withRoot(
      `/api/v1/author/library/collections${
        params.collectionId ? "/" + params.collectionId : ""
      }/topics/available`,
    ),
  )
}

export const getAvailableAssessments = async ({ params }) => {
  return await httpRequest.get(
    endpoint.withRoot(
      `/api/v1/author/reports/results/availableAssessments?search=${params.search}&limit=${params.limit}`,
    ),
  )
}
